<style>
.notice {
    background-color: rgb(255, 206, 116);
    border-radius: 15px;
    padding: 10px;
    margin-bottom: 30px;
    margin-top: 0px;
}

.misc-notice {
    background-color: #dfb8fd;
    border-radius: 15px;
    padding: 10px;
    margin-bottom: 20px;
    margin-top: 20px;
}

#welcome-banner {
    color:rgb(63, 63, 63);
    border-radius: 15px;
    font-size: 22px;
    line-height: 1.5em;
    margin-bottom: 30px;
}

.all-area-link {
    font-size: 12px;
    display: inline-block;
}

.featured-header {
    display: inline-block;
}

.all-button-holder {
    display: inline-block;
    padding-left: 10px;
}

h1 {
    margin-bottom: 10px;
}

.sign-up-button {
    color: white;
    background-color: #424242 !important;
    border-color: #333 !important;
}

.sign-up-button:hover {
    background-color: grey !important;
    border-color: grey !important;
}

.tags-holder {
    padding-bottom: 10px;
}

.tag {
    padding: 5px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 10px;
    background-color: rgb(235, 235, 243);
    color: grey;
    margin: 5px;
    margin-right: 10px;
    margin-left: 0px;
    display: inline-block;
    cursor: pointer;
}

.tag:hover {
    background-color: rgb(70, 70, 70);
    color: white;
}


@media (max-width:972px) {
    #welcome-banner {
        font-size: 1.2em;
        margin-bottom: 0px !important;
    }
    .all-area-link {
        font-size: 0.8em;
        padding: 5px;
        margin-top: 5px;
        margin-bottom: 5px;
        width: auto;
    }

    .notice {
        margin-bottom: 0px;
    }

    button {
        font-size: 12px;
    }
}
</style>

<script>
import {push} from './pt-router/Router.svelte'
import {onMount, afterUpdate} from 'svelte'
import * as Common from './Common.js'
import FeedView from './FeedView.svelte'
import FeaturedAreas from './FeaturedAreas.svelte'
import Spinner from './Spinner.svelte'

export let side

let recentTags = []
let feed = []
let areas = []
let inProgress = false
let scrollTopId = null
let scrollTopValue = 0

let playerholder
let showPlayer = false

let latestTimestamp = Math.floor(Date.now() / 1000)

onMount(async () => {
    let cachedFeedInfo = Common.getCachedFeed("welcome")
    if(cachedFeedInfo) {
        let info = JSON.parse(cachedFeedInfo)
        feed = info.feed
        latestTimestamp = feed[feed.length-1].data.createtime
        scrollTopId = info.itemId
        scrollTopValue = info.scrollTopValue
        Common.clearCachedFeed("welcome")
    } else {
        requestNextFeed()
    }

    Common.getData('areas/featured')
    .then(data => {
        areas = data.sort((a,b) => {
            return a.id > b.id;
        }).slice(0,4)
    })

    Common.getData('tags')
    .then(data => {
        recentTags = data
    })

    let parentevent = side.onscroll
    side.onscroll = () => {
        parentevent()
        if((side.scrollHeight - (side.scrollTop + side.clientHeight)) < 800) {
            requestNextFeed()
        }
    }
})

afterUpdate(() => {
    if(scrollTopId) {
        let elem = document.getElementById(scrollTopId)
        if(elem) {
            elem.scrollIntoView()
            side.scrollTop = scrollTopValue
            scrollTopId = null
        }
    }
})

function requestNextFeed() {
    if(inProgress) {
        return
    }
    inProgress = true

    Common.getData('recent?seen=' + latestTimestamp)
    .then(data => {
        if(data === null) {
            return
        }
        feed = feed.concat(data)
        console.log("FEED UPDATE:", feed)
        latestTimestamp = feed[feed.length-1].data.createtime
        inProgress = false
    })
}

</script>

<svelte:head>
<!-- Primary Meta Tags -->
	<title>Plan Together - Map Platform for Citizens</title>
	<meta name="title" content="Plan Together - Map Platform for Citizens">
	<meta name="description" content="A Collaborative Map Platform enabling Citizens, Planning Enthusiasts and Municipal Planners to talk, plan and learn about their communities.">

	<!-- Open Graph / Facebook -->
	<meta property="og:type" content="website">
	<meta property="og:url" content="https://plantogether.city">
	<meta property="og:title" content="Plan Together - Map Platform for Citizens">
	<meta property="og:description" content="A Collaborative Map Platform enabling Citizens, Planning Enthusiasts and Municipal Planners to talk, plan and learn about their communities.">
	<meta property="og:image" content="https://plantogether.city/screenshot_home.png">

	<!-- Twitter -->
	<meta property="twitter:card" content="summary_large_image">
	<meta property="twitter:url" content="https://plantogether.city">
	<meta property="twitter:title" content="Plan Together - Map Platform for Citizens">
	<meta property="twitter:description" content="A Collaborative Map Platform enabling Citizens, Planning Enthusiasts and Municipal Planners to talk, plan and learn about their communities.">
	<meta property="twitter:image" content="https://plantogether.city/screenshot_home.png">
</svelte:head>

{#if !Common.currentUserValue}
    <div id="welcome-banner">
        Plan Together is a Collaborative Map Platform enabling Citizens, Planning Enthusiasts and Municipal Planners to talk, plan and learn about their communities.
        <div style="font-size: 16px; padding-top: 10px; padding-bottom: 10px">
            <div class=" control-single sign-up-button" on:click={() => push('/login')}>Sign Up For Free</div>
            <!--<div class=" control-single" on:click={() => showPlayer = true}>&#9658; Watch Video</div>-->
            <div class=" control-single" on:click={() => push('/about')}>Learn More</div>
        </div>
    </div>
{/if}

<!--
{#if !Common.currentUserValue || (Common.currentUserValue.user_area_id === 0)}
    <div class="notice">
        Due to the intensification of the COVID-19 pandemic, we are providing free access to Plan Together’s municipal tools during this time. <a href="https://plantogether.city/tools-landing">Learn More.</a> 
    </div>
{/if}

<div class="misc-notice">
    The new Miscellaneous item type let's you contribute without the pressure! Have a casual chat about your area. <a href="https://plantogether.city/add-item/4">Use It Today!</a> 
</div>
-->

<div class="top">
    <h1 class="featured-header">Areas</h1><div class="all-button-holder"><a class="all-area-link" href="#/areas">See All...</a></div>
    <FeaturedAreas {areas}></FeaturedAreas>

    <h1>Top Tags</h1>
    <div class="tags-holder">
        {#each recentTags as tag}
            <div class="tag" on:click={()=> push('/tag/'+tag)}># {tag}</div>
        {/each}
    </div>
    <h1>Recent</h1>
</div>

<FeedView includeNames={true} displayAreaLabels={true} {feed} feedName={"welcome"} {side}></FeedView>
{#if inProgress}
    <Spinner></Spinner>
{/if}

{#if showPlayer}
    <div bind:this={playerholder} style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0, 0.8); z-index: 10000 !important; text-align: center; padding-top: 100px">
        {#if playerholder}
            <iframe width={playerholder.clientWidth*0.8} height={playerholder.clientWidth*0.8 * 0.5} src="https://www.youtube.com/embed/ukfiFJe9iq0?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        {/if}
        <div on:click={() => showPlayer = false} style="position: absolute; top: 0; right: 0; color: white; cursor: pointer; font-size: 24px; padding: 15px; padding-top: 100px;">
            x
        </div>
    </div>
{/if}